const groupTypes: Record<string, number> = {
  FOR_GROUP: 1,
  FOR_HABIT: 2,
  FOR_AUTO_RESPONDER: 3,
};
export default groupTypes;
